import { Glass } from "./Glass.tsx";
import { Shot } from "./Shot.tsx";
import { SITE_NAME } from "../lib/site.ts";

export function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 -top-40 -z-10 h-[42rem] bg-[radial-gradient(50%_50%_at_50%_30%,oklch(0.65_0_0/0.16),transparent_70%)]"
      />

      <div className="mx-auto w-full max-w-4xl px-6 pb-16 pt-10 text-center sm:pt-14">
        <h1 className="animate-rise text-balance text-[2.6rem] font-semibold leading-[1.08] tracking-tight sm:text-[3.25rem] lg:text-6xl">
          让每一次「久坐」都有结束点
        </h1>
        <p className="animate-rise mx-auto mt-5 max-w-2xl text-balance text-base leading-relaxed text-muted-foreground sm:text-lg">
          {SITE_NAME}
          是一款 Windows、macOS、Linux 可用的开源久坐提醒桌面应用。全屏倒计时明确打断连续伏案；提醒文字、工作时段和白名单都由你决定。
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#download"
            className="inline-flex h-12 items-center gap-2.5 rounded-full bg-primary px-7 text-[15px] font-medium text-primary-foreground shadow-lg shadow-black/20 transition-transform hover:-translate-y-0.5 active:translate-y-0"
          >
            下载官方版
          </a>
          <Glass
            as="a"
            intensity="cta"
            href="#pricing"
            className="inline-flex h-12 items-center gap-2 rounded-full border border-white/15 px-6 text-[15px] font-medium text-foreground/90 transition-transform hover:-translate-y-0.5"
          >
            查看价格
          </Glass>
        </div>
      </div>

      <div className="mx-auto w-full max-w-5xl px-6 pt-2 pb-12">
        <Shot
          src="/settings-reminder.png"
          alt="肛了么提醒设置：间隔、倒计时、工作时段与模板"
        />
      </div>

      <div className="mx-auto mt-2 flex max-w-4xl flex-col items-center gap-5 px-6 pb-16">
        <span className="text-sm font-medium text-muted-foreground">为长期电脑工作者设计</span>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-foreground">
          <span className="inline-flex items-center gap-2">
            <span className="font-mono text-muted-foreground">全屏</span>
            倒计时打断
          </span>
          <span className="inline-flex items-center gap-2">
            <span className="font-mono text-muted-foreground">白名单</span>
            自动跳过
          </span>
          <span className="inline-flex items-center gap-2">
            <span className="font-mono text-muted-foreground">离线</span>
            本机可用
          </span>
        </div>
      </div>
    </section>
  );
}
